import styled from 'styled-components';
export const Wrapper = styled.div`
  max-width: 1480px;
  padding: 0px 60px;
  margin: auto;
  @media (max-width: 1280px) {
    padding: 0px 30px;
  }
  @media (max-width: 768px) {
    padding: 0px 20px;
  }
`;
